// M13.4 — small render helper for the ecommerce family.
//
// Formats a numeric amount using `Intl.NumberFormat` with the property's
// resolved currency code (from `meta.currencyCode`, which the Admin API
// helper read-throughs from D1). Falls back to a plain locale-formatted
// number when `currencyCode` is null — the read-through helper degrades
// to null on Admin API failure rather than blocking the report.
//
// `compact` opts into the short "$12K" / "$1.2M" form for the KPI tile
// label cells; the per-row datatable cells stay on the full form so
// totals don't lose precision.

import { useMemo } from "react";
import { formatCurrencyOrNumber } from "./format-currency";

export interface CurrencyValueProps {
  value: number;
  /** ISO 4217 from `meta.currencyCode`. Null = render plain numbers. */
  currencyCode: string | null | undefined;
  /** Compact notation ("$12K" instead of "$12,430") for tight cells. */
  compact?: boolean;
  className?: string;
}

export function CurrencyValue({ value, currencyCode, compact, className }: CurrencyValueProps) {
  const formatted = useMemo(
    () => formatCurrencyOrNumber(value, currencyCode, compact),
    [value, currencyCode, compact],
  );
  return (
    <span className={className} style={{ fontVariantNumeric: "tabular-nums" }}>
      {formatted}
    </span>
  );
}
